import { dataArrowDownRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowDownRight = /*#__PURE__*/createIcon(dataArrowDownRight)
export default IconArrowDownRight
